export const ACCOUNT_SETUP_STUDENT_IMAGE_SET_STATUS =
  'ACCOUNT_SETUP_STUDENT_IMAGE_SET_STATUS';
export const ACCOUNT_SETUP_STUDENT_IMAGE_SET_IMAGE =
  'ACCOUNT_SETUP_STUDENT_IMAGE_SET_IMAGE';
export const ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_IMAGE =
  'ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_IMAGE';
export const ACCOUNT_SETUP_STUDENT_IMAGE_ERROR =
  'ACCOUNT_SETUP_STUDENT_IMAGE_ERROR';
export const ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_ERROR =
  'ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_ERROR';



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/studentinfo/types.js